import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MessageCircle, CheckCircle2, ShieldCheck, Clock, Users, HardHat, Briefcase, Calendar, Download } from 'lucide-react';
import { useProjects } from '../hooks/useProjects';
import { useClientLogos } from '../hooks/useClientLogos';
export function LandingPDFPage() {
  const {
    projects
  } = useProjects();
  const {
    logos
  } = useClientLogos();
  const featuredProjects = projects.filter(p => p.featured).slice(0, 3);
  const projectsToShow = featuredProjects.length > 0 ? featuredProjects : projects.slice(0, 3);
  const handlePrint = () => {
    window.print();
  };
  return <div className="min-h-screen bg-white font-sans text-gray-900 print:text-black" data-id="element-806">
      {/* Print Controls - Hidden in print */}
      <div className="fixed top-4 right-4 z-50 print:hidden flex gap-2" data-id="element-807">
        <button onClick={handlePrint} className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold px-6 py-3 rounded-full shadow-lg transition-colors" data-id="element-808">
          <Download className="h-5 w-5" data-id="element-809" />
          Exportar PDF
        </button>
        <Link to="/" className="inline-flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium px-6 py-3 rounded-full transition-colors" data-id="element-810">
          ← Volver
        </Link>
      </div>

      {/* ===== HERO - Solo fondo oscuro sin imagen ===== */}
      <section className="relative min-h-screen w-full overflow-hidden bg-gray-900 print:min-h-0 print:h-auto print:py-20" data-id="element-811">
        {/* Background - Solo gradiente oscuro, sin imagen */}
        <div className="absolute inset-0 z-0" data-id="element-812">
          <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-blue-900/50 to-gray-900" data-id="element-813" />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/60 to-transparent z-10" data-id="element-814" />
        </div>
      </section>

      {/* ===== CLIENT LOGOS ===== */}
      {logos.length > 0 && <section className="py-12 sm:py-16 md:py-20 bg-white border-y border-gray-100 print:py-12" data-id="element-815">
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-816">
            <div className="text-center mb-8 sm:mb-12" data-id="element-817">
              <p className="text-xs sm:text-sm font-bold uppercase tracking-wider text-gray-500 mb-1 sm:mb-2" data-id="element-818">
                Confían en nosotros
              </p>
              <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-900" data-id="element-819">
                Empresas líderes que construyen con FORAX
              </h2>
            </div>
            <div className="flex flex-wrap justify-center items-center gap-8 sm:gap-10 md:gap-12" data-id="element-820">
              {logos.slice(0, 10).map(logo => <div key={logo.id} className="flex-shrink-0 w-32 sm:w-36 md:w-40 h-20 sm:h-22 md:h-24 flex items-center justify-center px-3" title={logo.name} data-id="element-821">
                  <img src={logo.url} alt={logo.name} className="w-full max-h-14 sm:max-h-16 md:max-h-18 object-contain grayscale opacity-60" data-id="element-822" />
                </div>)}
            </div>
          </div>
        </section>}

      {/* ===== ABOUT + STATS - Igual que About.tsx ===== */}
      <section className="bg-white py-16 sm:py-24 lg:py-32 overflow-hidden print:py-16" data-id="element-823">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-824">
          <div className="text-center max-w-5xl mx-auto" data-id="element-825">
            {/* Badge */}
            <div className="mb-6 inline-flex items-center gap-2 rounded-full bg-blue-50 px-4 py-2 text-sm font-bold text-blue-600 print:bg-blue-100" data-id="element-826">
              <span className="h-2 w-2 rounded-full bg-blue-600" data-id="element-827" />
              QUIÉNES SOMOS
            </div>

            {/* Title */}
            <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight text-gray-900 mb-12 sm:mb-16" data-id="element-828">
              40 años redefiniendo <br data-id="element-829" />
              <span className="text-blue-600" data-id="element-830">el estándar constructivo.</span>
            </h2>

            {/* Stats */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-12 sm:gap-16 max-w-5xl mx-auto" data-id="element-831">
              {[{
              value: '160+',
              label: 'Obras entregadas'
            }, {
              value: '75.000+',
              label: 'm² habilitados'
            }, {
              value: '35+',
              label: 'Clientes'
            }].map(stat => <div key={stat.label} className="text-center" data-id="element-832">
                  <div className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-2 tabular-nums" data-id="element-833">
                    {stat.value}
                  </div>
                  <div className="text-sm sm:text-base font-semibold text-gray-500 uppercase tracking-wider" data-id="element-834">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* ===== SPECIALTIES - Igual que Specialties.tsx ===== */}
      <section className="bg-white py-12 sm:py-16 md:py-20 lg:py-24 print:py-16" data-id="element-835">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-836">
          <div className="mb-8 sm:mb-12 md:mb-16" data-id="element-837">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl md:text-5xl" data-id="element-838">
              Nuestros servicios constructivos
            </h2>
            <p className="mt-3 sm:mt-4 max-w-3xl text-base sm:text-lg md:text-xl text-gray-500" data-id="element-839">
              Nos especializamos en la construcción y habilitación de espacios
              corporativos y comerciales, adaptando cada proyecto a las
              necesidades operativas y estándares de marca de nuestros clientes.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6 sm:gap-8 lg:gap-10 lg:grid-cols-2" data-id="element-840">
            {/* Oficinas Block */}
            <div className="relative overflow-hidden rounded-[2rem] sm:rounded-[2.5rem] bg-gray-50" data-id="element-841">
              <div className="aspect-[16/9] w-full overflow-hidden" data-id="element-842">
                <img src="https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&q=80&w=1200" alt="Oficinas corporativas modernas" className="h-full w-full object-cover" data-id="element-843" />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent" data-id="element-844" />
              </div>
              <div className="absolute bottom-0 left-0 p-6 sm:p-8 md:p-10 w-full" data-id="element-845">
                <h3 className="mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold text-white" data-id="element-846">
                  Oficinas
                </h3>
                <ul className="space-y-2 sm:space-y-3" data-id="element-847">
                  {['Habilitación corporativa', 'Remodelaciones', 'Estándares de marca'].map(item => <li key={item} className="flex items-center text-gray-200 font-medium text-sm sm:text-base" data-id="element-848">
                      <CheckCircle2 className="mr-3 h-5 w-5 text-blue-400" data-id="element-849" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>

            {/* Retail Block */}
            <div className="relative overflow-hidden rounded-[2rem] sm:rounded-[2.5rem] bg-gray-50" data-id="element-850">
              <div className="aspect-[16/9] w-full overflow-hidden" data-id="element-851">
                <img src="https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?auto=format&fit=crop&q=80&w=1200" alt="Espacio de retail moderno" className="h-full w-full object-cover" data-id="element-852" />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent" data-id="element-853" />
              </div>
              <div className="absolute bottom-0 left-0 p-6 sm:p-8 md:p-10 w-full" data-id="element-854">
                <h3 className="mb-4 sm:mb-6 text-2xl sm:text-3xl font-bold text-white" data-id="element-855">
                  Retail
                </h3>
                <ul className="space-y-2 sm:space-y-3" data-id="element-856">
                  {['Locales comerciales', 'Strip centers', 'Sucursales bancarias'].map(item => <li key={item} className="flex items-center text-gray-200 font-medium text-sm sm:text-base" data-id="element-857">
                      <CheckCircle2 className="mr-3 h-5 w-5 text-indigo-400" data-id="element-858" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== WHY FORAX - Igual que WhyForax.tsx ===== */}
      <section className="relative py-16 sm:py-24 overflow-hidden print:py-16" data-id="element-859">
        {/* Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-indigo-900 to-blue-950" data-id="element-860" />

        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-861">
          <div className="mb-12 sm:mb-20 text-center" data-id="element-862">
            <h2 className="text-3xl font-extrabold text-white sm:text-4xl md:text-5xl" data-id="element-863">
              ¿Por qué Forax?
            </h2>
            <p className="mt-4 text-lg sm:text-xl text-blue-200" data-id="element-864">
              Solidez y confianza para tu inversión.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-865">
            {[{
            icon: Briefcase,
            title: '40 años de experiencia',
            description: 'Trayectoria comprobable en el mercado chileno.'
          }, {
            icon: HardHat,
            title: 'Especialistas corporativos',
            description: 'Foco exclusivo en oficinas y retail, no vivienda.'
          }, {
            icon: Clock,
            title: 'Cumplimiento de plazos',
            description: 'El tiempo es crítico para tu operación.'
          }, {
            icon: Users,
            title: 'Coordinación integral',
            description: 'Gestión completa de obra y especialidades.'
          }, {
            icon: ShieldCheck,
            title: 'Enfoque operativo',
            description: 'Construimos pensando en el uso diario.'
          }].map((reason, index) => <div key={index} className="flex flex-col items-start rounded-2xl sm:rounded-3xl bg-white/5 p-6 sm:p-8 border border-white/10" data-id="element-866">
                <div className="mb-4 sm:mb-6 rounded-2xl bg-blue-500/20 p-3 text-blue-300" data-id="element-867">
                  <reason.icon className="h-7 w-7 sm:h-8 sm:w-8" data-id="element-868" />
                </div>
                <h3 className="mb-2 sm:mb-3 text-lg sm:text-xl font-bold text-white" data-id="element-869">
                  {reason.title}
                </h3>
                <p className="text-blue-100/80 leading-relaxed text-sm sm:text-base" data-id="element-870">
                  {reason.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* ===== PROJECTS GALLERY - Igual que ProjectsGallery.tsx ===== */}
      <section className="bg-gray-50 py-16 sm:py-24 lg:py-32 print:py-16 print:bg-gray-100" data-id="element-871">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-872">
          <div className="mb-12 sm:mb-16 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end" data-id="element-873">
            <div data-id="element-874">
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900" data-id="element-875">
                Algunas de nuestras obras
              </h2>
              <p className="mt-3 sm:mt-4 text-lg sm:text-xl text-gray-500" data-id="element-876">
                Calidad, orden y detalle en cada ejecución.
              </p>
            </div>
            <div className="rounded-full border border-gray-300 px-6 py-2 font-semibold text-gray-600 text-sm sm:text-base" data-id="element-877">
              Ver otras obras terminadas
            </div>
          </div>

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-878">
            {projectsToShow.map(project => <div key={project.id} className="relative aspect-[4/3] overflow-hidden rounded-2xl sm:rounded-3xl bg-gray-200 shadow-md" data-id="element-879">
                <img src={project.images[0]} alt={project.name} className="h-full w-full object-cover" data-id="element-880" />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/90 via-gray-900/40 to-transparent" data-id="element-881" />
                <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-882">
                  <span className="mb-2 inline-block rounded-full bg-blue-600 px-3 py-1 text-xs font-bold text-white shadow-lg" data-id="element-883">
                    {project.category}
                  </span>
                  <p className="text-lg font-bold text-white mb-2" data-id="element-884">
                    {project.name}
                  </p>
                  <div className="flex gap-3 text-white/90 text-sm" data-id="element-885">
                    <span data-id="element-886">{project.year}</span>
                    <span data-id="element-887">•</span>
                    <span data-id="element-888">{project.m2.toLocaleString()} m²</span>
                    <span data-id="element-889">•</span>
                    <span data-id="element-890">{project.comuna}</span>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* ===== FINAL CTA - Igual que FinalCTA.tsx ===== */}
      <section className="py-16 sm:py-20 md:py-24 lg:py-32 bg-white print:py-16" data-id="element-891">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8" data-id="element-892">
          <div className="relative overflow-hidden rounded-[2rem] sm:rounded-[2.5rem] md:rounded-[3rem] bg-gradient-to-br from-blue-600 to-indigo-700 px-6 py-16 sm:px-8 sm:py-20 md:px-12 md:py-24 text-center shadow-2xl shadow-blue-900/20" data-id="element-893">
            {/* Decorative circles */}
            <div className="absolute -top-24 -left-24 h-64 w-64 rounded-full bg-white/10 blur-3xl print:hidden" data-id="element-894" />
            <div className="absolute -bottom-24 -right-24 h-64 w-64 rounded-full bg-blue-400/20 blur-3xl print:hidden" data-id="element-895" />

            <div className="relative z-10" data-id="element-896">
              <h2 className="mb-6 sm:mb-8 text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white" data-id="element-897">
                ¿Listo para construir?
              </h2>
              <p className="mx-auto mb-8 sm:mb-10 md:mb-12 max-w-2xl text-base sm:text-lg md:text-xl text-blue-100" data-id="element-898">
                Conversemos sobre cómo podemos materializar tu visión con los
                más altos estándares de calidad y diseño.
              </p>

              <div className="flex flex-col items-center justify-center gap-4 sm:flex-row sm:flex-wrap" data-id="element-899">
                <div className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full bg-white px-8 sm:px-10 py-4 sm:py-5 text-base sm:text-lg font-bold text-blue-600 shadow-xl" data-id="element-900">
                  Contactar a Forax
                  <ArrowRight className="h-5 w-5" data-id="element-901" />
                </div>

                <div className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/30 bg-transparent px-8 sm:px-10 py-4 sm:py-5 text-base sm:text-lg font-bold text-white" data-id="element-902">
                  <MessageCircle className="h-5 w-5" data-id="element-903" />
                  WhatsApp
                </div>

                <div className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full border-2 border-white/30 bg-transparent px-8 sm:px-10 py-4 sm:py-5 text-base sm:text-lg font-bold text-white" data-id="element-904">
                  <Calendar className="h-5 w-5" data-id="element-905" />
                  Agendar reunión
                </div>
              </div>

              {/* Contact info for print */}
              <div className="mt-12 pt-8 border-t border-white/20 text-blue-100 text-sm" data-id="element-906">
                <p className="font-semibold text-white mb-2" data-id="element-907">
                  Contacto directo:
                </p>
                <p data-id="element-908">
                  contacto@forax.cl · +56 9 9218 0727 · calendly.com/jrb-forax
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className="bg-gray-900 text-white pt-12 pb-8 rounded-t-[3rem] print:rounded-none print:pt-8" data-id="element-909">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-910">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-911">
            <span className="text-3xl font-black tracking-tighter" data-id="element-912">
              FORAX<span className="text-blue-500" data-id="element-913">.</span>
            </span>
            <p className="text-gray-400 text-sm" data-id="element-914">
              © {new Date().getFullYear()} FORAX Construcción · 40 años
              construyendo confianza
            </p>
          </div>
        </div>
      </footer>

      {/* Print Styles */}
      <style data-id="element-915">{`
        @media print {
          @page {
            size: A4;
            margin: 0.5cm;
          }
          body {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .print\\:hidden {
            display: none !important;
          }
        }
      `}</style>
    </div>;
}